import Hero from "@/components/home/Hero";
import AboutSection from "@/components/home/AboutSection";
import ServicesSection from "@/components/home/ServicesSection";
import ProcessSection from "@/components/home/ProcessSection";
import ExpertiseSection from "@/components/home/ExpertiseSection";
import WhyChooseSection from "@/components/home/WhyChooseSection";
import IndustriesSection from "@/components/home/IndustriesSection";
import AchievementsSection from "@/components/home/AchievementsSection";
import ExpertsSection from "@/components/home/ExpertsSection";
import { CTASection } from "@/components/CTASection";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo(
    "AutoDrive Tech Solutions | Automotive Certification & Regulatory Consulting India",
    "AutoDrive Tech Solutions provides end-to-end automotive certification, type approval, homologation, testing management and regulatory consulting for India's automotive industry."
  );
  return (
    <>
      <Hero />
      <AboutSection />
      <ServicesSection />
      <ProcessSection />
      <ExpertiseSection />
      <WhyChooseSection />
      <IndustriesSection />
      <AchievementsSection />
      <ExpertsSection />
      <CTASection />
    </>
  );
}
